import { render, staticRenderFns } from "./DonutChart89.vue?vue&type=template&id=1433c8de&scoped=true"
import script from "./DonutChart89.vue?vue&type=script&lang=js"
export * from "./DonutChart89.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1433c8de",
  null
  
)

export default component.exports